import { getSource, isGifDeviation, isVideoDeviation } from '../DeviationViews/_helpers';
import DeviationMediaService from './DeviationMediaService';
export function elmoSaysThisMightBeADeviationUrl(url) {
    if (!url) {
        return;
    }
    /*
    1. :thumbcode: - the deviation id may come from a thumb code
    :thumb123456:
  */ let matches = url.match(/^:thumb(\d+):$/);
    if (matches) {
        return {
            deviationid: parseInt(matches[1]),
            type: 'art'
        };
    }
    /*
    2. supebrowse link -- HAS TO GO FIRST because SB links can be appended to OTHER valid links
    URL scheme:   https://*.deviantart.com/*#/d*
    https://randomduck.deviantart.com/gallery/#/d2k5cau
  */ matches = url.match(/deviantart\.(com|lan).*#\/d([0-9a-z]+)/);
    if (matches) {
        return {
            deviationid: parseInt(parseInt(matches[2], 36).toString(10)),
            type: 'art'
        };
    }
    /*
    3a. subdomainfree canonical link
    URL scheme:   https://www.deviantart.com/user/art/*(*)
    https://www.deviantart.com/randomduck/art/test-ignore-589-154773894?q=portal%3A%2F%2Fdeviations%2F%3Fcategory.order%3Dfresh%26gs.mode%3Dthumbs&qo=2
  */ matches = url.match(/deviantart\.(com|lan)\/((?:[0-9A-Za-z-_]+))\/((?:art|journal|status-update|commission|poll|tier))\/.*-(\d+)/);
    if (matches) {
        return {
            deviationid: parseInt(matches[4]),
            type: matches[3] || 'art',
            username: matches[2]
        };
    }
    /*
    3b. canonical link
    URL scheme:   https://*.deviantart.com/art/*(*)
    https://randomduck.deviantart.com/art/test-ignore-589-154773894?q=portal%3A%2F%2Fdeviations%2F%3Fcategory.order%3Dfresh%26gs.mode%3Dthumbs&qo=2
  */ matches = url.match(/deviantart\.(com|lan)\/(?:art|journal)\/.*-(\d+)/);
    if (matches) {
        return {
            deviationid: parseInt(matches[2]),
            type: 'art'
        };
    }
    /*
    4. fav.me  link
    URL scheme:   https://fav.me/d[devid] where devid is in base 36
    https://fav.me/d2k5cau

    URL scheme:   https://fav.me/[devid] where devid is in base 10
    https://fav.me/750477558
  */ matches = url.match(/fav\.me\/d([0-9a-z]+)/);
    if (matches) {
        return {
            deviationid: parseInt(parseInt(matches[1], 36).toString(10)),
            type: 'art'
        };
    }
    matches = url.match(/fav\.me\/([0-9]+)/);
    if (matches) {
        return {
            deviationid: parseInt(matches[1]),
            type: 'art'
        };
    }
    /*
    5. really old link
    URL scheme:   https://www.deviantart.com/deviation/*
    https://www.deviantart.com/deviation/154773894/
  */ matches = url.match(/www\.deviantart\.(com|lan)\/deviation\/(\d+)/);
    if (matches) {
        return {
            deviationid: parseInt(matches[2]),
            type: 'art'
        };
    }
    /*
    6. really, really old link
    URL scheme:   https://www.deviantart.com/view/*
    https://www.deviantart.com/view/154773894/
  */ matches = url.match(/www\.deviantart\.(com|lan)\/view\/(\d+)/);
    if (matches) {
        return {
            deviationid: parseInt(matches[2]),
            type: 'art'
        };
    }
    /*
    7. sta.sh short link
    URL scheme:   https://sta.sh/0*
    https://sta.sh/018bxsl3dm4o
  */ matches = url.match(/sta\.(sh|nk)\/0([0-9a-z]+)/);
    if (matches) {
        return {
            deviationid: parseInt(parseInt(matches[2], 36).toString(10)),
            type: 'art'
        };
    }
    /*
    8. sta.sh long link
    URL scheme:   https://sta.sh/1*
    https://sta.sh/14502318545176648
  */ matches = url.match(/sta\.(sh|nk)\/1([0-9a-z]+)/);
    if (matches) {
        return {
            deviationid: parseInt(matches[2]),
            type: 'art'
        };
    }
    /*
    9. sta.sh eclipsed link
    URL scheme:   https://www.deviantart.com/stash/0*
    https://deviantart.com/stash/018bxsl3dm4o
  */ matches = url.match(/www\.deviantart\.(com|lan)\/stash\/0([0-9a-z]+)/);
    if (matches) {
        return {
            deviationid: parseInt(parseInt(matches[2], 36).toString(10)),
            type: 'art'
        };
    }
}
/** returns 'video' or 'gif' if the deviation is either, undefined if neither */ export function isVideoOrGif(deviation) {
    if (isVideoDeviation(deviation)) {
        return 'video';
    }
    if (isGifDeviation(deviation)) {
        return 'gif';
    }
}
/** returns the deviation's duration if it's a video, undefined if not */ export function getVideoDuration(deviation) {
    const videoFile = getSource(DeviationMediaService.getMediaByType(deviation, 'video'));
    return videoFile === null || videoFile === void 0 ? void 0 : videoFile.duration;
}
/** returns the extended deviation's original file struct (if available) */ export function getDeviationOriginalFile(deviation) {
    var _deviation_extended;
    return deviation === null || deviation === void 0 ? void 0 : (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.originalFile;
}

//# sourceMappingURL=deviations.js.map